module.exports = __webpack_public_path__ + "img/skills-logo.01b84b3c.png";